import React from "react";
import { ExperienceSelector } from "@origin-digital/features";
import { Navigation, NavigationProps } from "./Navigation";
import { IMenuItem } from "./IMenuItem";

interface UpdateNavFunction {
  (menuItems: IMenuItem[], content: { links: IMenuItem[] }): IMenuItem[];
}

interface NavigationWithExperienceProps extends NavigationProps {
  mbox: string;
  updateNavFunction: UpdateNavFunction;
}

export const NavigationWithExperience = (
  props: NavigationWithExperienceProps
) => {
  const {
    mbox,
    menuItems,
    activeDropdownMenuIndex,
    activeTopMenuIndex,
    updateNavFunction
  } = props;
  return (
    <ExperienceSelector mbox={mbox}>
      {content => (
        <Navigation
          menuItems={
            Object.entries(content).length === 0
              ? menuItems
              : updateNavFunction(menuItems, content)
          }
          activeDropdownMenuIndex={activeDropdownMenuIndex}
          activeTopMenuIndex={activeTopMenuIndex}
        />
      )}
    </ExperienceSelector>
  );
};
